import { CoreUiInteractionEvent, generateTrackingKey } from "@obg/ngx.core";
import { TrackingContext } from "@obg/ngx.ui.core";

import { LoginSupportInteractionEvent } from "./auth/auth-telemetry.const";

export const COMMON_UI_INTERACTION_TRACKING_MAP: Record<string, any> = {
	[generateTrackingKey(TrackingContext.LobbySelectorInteractionContext, CoreUiInteractionEvent.DropDown)]: {
		event: "TopBurgerMenuClick",
	},
	[generateTrackingKey(TrackingContext.LobbySelectorInteractionContext, CoreUiInteractionEvent.LobbyChange)]: {
		event: "TopBurgerMenuClick",
	},
	[generateTrackingKey(TrackingContext.MenuInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "MenuClick",
	},
	[generateTrackingKey(TrackingContext.BurgerMenuInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "BurgerMenuClick",
	},
	[generateTrackingKey(TrackingContext.NavbarInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "TopNavigationClick",
	},
	[generateTrackingKey(TrackingContext.ProductSelectorInteractionContext, CoreUiInteractionEvent.LobbyChange)]: {
		event: "MainNavigationClick",
	},
	[generateTrackingKey(TrackingContext.CasinoTabInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "MainNavigationClick",
	},
	[generateTrackingKey(TrackingContext.FooterInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "BottomNavigationClick",
	},
	[generateTrackingKey(TrackingContext.MyAccountInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "MyAccountClick",
	},
	[generateTrackingKey(TrackingContext.MyAccountInteractionContext, CoreUiInteractionEvent.UserStateChange)]: {
		event: "MyAccountClick",
	},
	[generateTrackingKey(TrackingContext.RegulatoryBarInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "SGAHeaderLogo",
	},
	[generateTrackingKey(TrackingContext.LoginSupportInteractionContext, LoginSupportInteractionEvent.ForgotPassword)]:
		{
			event: "ForgottenPassword",
		},
	[generateTrackingKey(TrackingContext.LoginSupportInteractionContext, LoginSupportInteractionEvent.Register)]: {
		event: "CreateAccount",
	},
};
